import { Payer } from "@/src/models/payer";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getAllPayers(): Promise<Payer[]> {
  return fetchJSON<Payer[]>("/api/payer");
}

export async function getPayerByShortId(shortId: string): Promise<Payer | null> {
  return fetchJSON<Payer | null>(`/api/payer/${shortId}`);
}
